export const MINUTES_ALLOW_TO_JOIN = 15;

export const EMAIL = 'MIRA-experience@emirates.com';
